import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Field, inputCls } from "./ui";

const FIELDS = [["name", "Nome"], ["whatsapp", "WhatsApp"], ["email", "E-mail"], ["telegram", "Telegram"],
  ["username", "Usuário (login)"], ["password", "Senha"], ["plan_price", "Valor do plano (R$)"]];

export const EditPanelDialog = ({ c, onClose, onDone }) => {
  const init = { name: c.name || "", whatsapp: c.whatsapp || "", email: c.email || "", telegram: c.telegram || "",
    username: c.panel_user || "", password: c.panel_password || "", plan_price: c.value ?? "", note: c.notes || "" };
  const [f, setF] = useState(init);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    const diff = {};
    Object.keys(f).forEach((k) => { if (String(f[k]) !== String(init[k])) diff[k] = k === "plan_price" ? parseFloat(f[k]) : f[k]; });
    if (!Object.keys(diff).length) return toast.info("Nada foi alterado");
    setBusy(true);
    try {
      const { data } = await api.put(`/clients/${c.id}/panel`, diff);
      toast.success("Cliente atualizado no SYSLOG");
      onDone(data.client);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar"); }
    setBusy(false);
  };

  return (
    <Modal testid="edit-panel-dialog" title="Editar cliente (SYSLOG + CRM)" onClose={onClose} wide>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <Field key={k} label={label}>
            <input data-testid={`edit-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inputCls} />
          </Field>
        ))}
        <div className="sm:col-span-2">
          <Field label="Observação">
            <textarea data-testid="edit-note" rows={3} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className={inputCls} />
          </Field>
        </div>
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <Btn tone="ghost" onClick={onClose}>Cancelar</Btn>
        <Btn data-testid="edit-save" disabled={busy} onClick={save}>{busy ? "Salvando..." : "Salvar no SYSLOG"}</Btn>
      </div>
    </Modal>
  );
};
